import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_wjpfk5j84w: FaireBrandEntity = {
  token: "b_wjpfk5j84w",
  type: "brand",
  name: "Morning Dew Designs",
  avatarUrl:
    "https://cdn.faire.com/fastly/17c05875dcfc289ed111a14f5befe63dca721b50289db4f9c6757fde97bab4a7.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/af5e53d65f100121228e781ce484748ea41a7bd0977eab0a38365d718c8b622c.png",
  logoUrl:
    "https://cdn.faire.com/fastly/17c05875dcfc289ed111a14f5befe63dca721b50289db4f9c6757fde97bab4a7.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/af5e53d65f100121228e781ce484748ea41a7bd0977eab0a38365d718c8b622c.png",
  location: "Byron Center, MI, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 21,
  isTopShop: true,
  isInsider: true,
  description:
    "Processing Lead Time Update:\nI will be away on vacation February 13th through March 2nd, 2026. Instead of putting my shop in vacation mode, I prefer to extend the lead times so that you can continue to grab the cute products you want. Your orders will ship the week of March 2nd, 2026.\n\nMorning Dew Designs is a Michigan-based small business where I’ve turned my passion for creativity and design into a unique venture working with polymer clay. I’m constantly inspired by its versatility and the limitless possibilities it offers when you think outside the box. After three years of growth, this business has not only supported my family’s needs but has also allowed me to give back to the community. Ten percent of my income is donated to local organizations that provide essential support to those in need, helping to make a difference for the less fortunate in our area.",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:58.488Z",
    importedBy: "entity-db-cli",
  },
};
